<app-auth-connect-header [isBackButton]="true"></app-auth-connect-header>
<div class="form-body" *ngIf="page !== 'updatepass'">
  <form #forgotPasswordForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="email fields" *ngIf="page === 'forgotpass'">
      <app-input
        [type]="'email'"
        name="email"
        [formGroup]="forgotPasswordForm"
        [(ngModel)]="userProfile.email"
        label="Email"
        [placeholder]="'Email'"
        required
        pattern="^[\w.!#$%&'*+/=?^_`{|}~-]+@[\w](?:[\w-]{0,61}[\w])?(?:\.[\w](?:[\w-]{0,61}[\w])?)*$"
        [isEditable]="true"
      ></app-input>
    </div>

    <!-- OTP -->
    <div class="otp" *ngIf="page === 'otp'">
      <ngx-otp-input
        [config]="otpInputConfig"
        (otpChange)="handleOtpChange($event)"
        (fill)="handleFillEvent($event)"
      >
      </ngx-otp-input>
    </div>

    <!-- action -->
    <div class="submitButton">
      <button
        *ngIf="page === 'forgotpass'"
        class="p-button l-form-button l-body-bold"
        type="submit"
        [disabled]="!forgotPasswordForm.valid"
      >
        Send Verification Code
      </button>
      <button
        *ngIf="page === 'otp'"
        class="p-button l-form-button l-body-bold"
        type="submit"
        [disabled]="!isValid"
      >
        Continue
      </button>
      <div class="alreadyacc-login" *ngIf="page === 'otp'">
        <span class="heading-sec">
            <span class="heading-sec-one">Didn’t receive the code?&nbsp;&nbsp;</span>
          <span class="heading-sec-two tertiary-button" (click)="sendOTP()">Resend it</span>
        </span>
      </div>

      <div class="alreadyacc-login" *ngIf="page === 'forgotpass'" (click)="navigate('login')">
        <span class="heading-sec">
          <span
            class="heading-sec-one"
            [ngStyle]="{ color: 'var(--l-secondary-tenant-color, #6F6F6F)' }"
            style="cursor: pointer"
            >Back to login</span
          >
        </span>
      </div>
    </div>
  </form>
</div>

<div class="form-body" *ngIf="page === 'updatepass'">
  <form #authForm="ngForm" (ngSubmit)="updatePassword()">
    <app-update-password [authForm]="authForm" [userProfile]="userProfile"></app-update-password>
    <div class="submitButton">
      <button
        class="p-button l-form-button l-body-bold"
        type="submit"
        [disabled]="!authForm.valid"
      >
        Continue
      </button>
    </div>
  </form>
</div>
<app-toast></app-toast>
